import { User } from '../EnumTypes/ActionEnumTypes';
import * as UserModule from '../../../Modules/UserModule';

const init = () => ({
  type: User.GET_USERS_LABEL_INIT,
});

const success = (data: any) => ({
  type: User.GET_USERS_LABEL_SUCCESS,
  payload: {
    data: data,
  },
});

const failure = () => ({
  type: User.GET_USERS_LABEL_FAILURE,
});

const getUsersList = () => async (dispatch) => {
  dispatch(init());
  try {
    const data = await UserModule.Connector.getUsersLabel();
    dispatch(success(data.data.userLabel));
  } catch (err: any) {
    dispatch(failure());
    console.log('GET_USERS_LABEL', err.response);
  }
};

export default getUsersList;
